<template>
	<div class="container">
		<div class="row">
			<div class="col-12 col-sm-5 text-center text-sm-left">
				<h3 class="font-weight-bold ">Users - Leaderboard</h3>
			</div>
			<div class="col-12 col-sm-5 d-inline-flex justify-content-between " v-bind:class="!is_admin ? 'offset-sm-2' : ''">
				<custom_select
					empty_message=""
					name="selected_filter"
					no_selection_name="-- Select --"
					extra_class="text-pink text-center"
					:pre_selected="content_filter"
					:in_line="true"
					:options="leaderboard_filter_options"
					@selected="selectFilter"
				></custom_select>
				<button @click="show_deleted = !show_deleted" class="btn btn-primary">
					<span v-if="show_deleted === true">Users</span>
					<span v-else>Deleted Users</span>
				</button>
			</div>
			<div v-if="is_admin" class="col-12 col-sm-2 text-center text-sm-left">
				<a :href="user_create_url" class="btn btn-primary">Create</a>
			</div>
		</div>
		<div class="row mt-1">
			<div class="leader-board-table">
				<div class="leader-board-table--wrapper">
					<div class="leader-board-table--wrapper-header row">
						<div class="col-1">Pos</div>
						<div class="col-4">Name</div>
						<div v-if="is_admin" class="col-1">Admin</div>
						<div class="col text-center">Audits</div>
						<div class="col text-center">Avg Score</div>
						<div v-if="is_admin" class="col text-center">Actions</div>
					</div>

					<div class="leader-board-table--wrapper-body">
						<div
							class="leader-board-table--row row"
							v-for="(row, index) in users"
							v-bind:class="{
								highlight: row.id === user.id,
								deleted: !row.active
							}"
						>
							<div class="col-1 py-0 px-2 text-center">
								<div class="leader-board-table--position">{{parseInt(index)+ 1}}</div>
							</div>
							<div class="col-4">
								<div class="w-100 leader-board-table--value">{{row.first_name + ' ' + row.last_name}}</div>
							</div>
							<div v-if="is_admin" class="col-1">
								<span v-if="row.is_admin" class="just-tick m-auto"></span>
							</div>
							<div class="col text-center">
								{{row.num_audits}}
							</div>
							<div class="col text-center">
								<span class="text-pink">{{Math.round(row.avg_audit_score) + '%'}}</span>

								<!-- <span v-if="row.avg_audit_score < 70" class="text-pale-yellow">{{Math.round(row.avg_audit_score) + '%'}}</span>
								<span v-else-if="row.avg_audit_score < 80" class="text-yellow">{{Math.round(row.avg_audit_score) + '%'}}</span>
								<span v-else>{{Math.round(row.avg_audit_score) + '%'}}</span> -->
							</div>
							<div v-if="is_admin && !row.active" class="col text-center">
								<button @click="restoreUser(row.id)" class="btn btn-sm btn-primary"><i class="fa fa-undo"></i></button>
							</div>
							<div v-if="is_admin && row.active" class="col text-center">
								<a :href="user_edit_url.replace('?', row.id)" class="btn btn-sm btn-primary"><i class="fa fa-pencil"></i></a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import CustomSelectComponent from '../general_components/CustomSelectComponent.vue';

	import URLEditing from '../../helpers/URLEditing';

	export default {
		components:{
			'custom_select': CustomSelectComponent
		},

		props:[
			'user',
			'user_create_url',
			'user_edit_url',
			'user_restore_url',
			'is_admin',
			'load_data_url',
			'filter_by',
		],

		data(){
			return {
				show_deleted: false,
				current_users: [],
				deleted_users: [],
				content_filter: '',
				leaderboard_filter_options: [
					{
						label: 'This year',
						value: 'year'
					},
					{
						label: 'This month',
						value: 'month'
                    },
                    {
                        label: 'Last month',
                        value: 'last_month'
					}
				]
			}
		},

		beforeMount(){
			this.content_filter = this.filter_by;
			this.loadData()
		},

		methods: {
			loadData(){
				let _this = this;
				let data = {
						filter: _this.content_filter,
						deleted: _this.show_deleted_users
				}
				axios.post(_this.load_data_url, data)
				.then(response => {
					_this.deleted_users = response.data.deleted_users
					_this.current_users = response.data.current_users
				})
				.catch(error => {
					console.log('no success')
				});
			},

			selectFilter(e) {
				this.content_filter = e.value;
				this.loadData();
			},

			restoreUser(user_id){
				let _this = this;
				axios.get(_this.user_restore_url.replace('?', user_id))
				.then(response => {
					this.loadData()
				})
				.catch(error => {
					console.log('no success')
				});
			}
		},
		computed: {
			users(){
				if(this.show_deleted === true){
					return this.deleted_users
				}else{
					return this.current_users
				}
			}
		}
	}
</script>
